

import './index.scss'

const Logo = () => {


  return (
    <div className="logo-container" >
      <a href="https://pokem-api.netlify.app/" target="_blank" rel="noreferrer">
          <img
            src="./poke.png"
            alt="example"
          />
        </a>
    </div>
  )
}

export default Logo
